<template>
    <div class="footer__contacts">
        <div class="footer__contacts-item">
            {{ company }}<br>
            {{ address }}<br>
            Register Number: {{ regNum }}
        </div>
        <div class="footer__contacts-item mt-auto">
            email: {{ mailTo }}<br>
            tel: {{ phone }}<br>
            Customer Support 24/7
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
          company: import.meta.env.VITE_COMPANY,
          address: import.meta.env.VITE_ADDRESS,
          country: import.meta.env.VITE_COUNTRY,
          regNum: import.meta.env.VITE_REG_NUM,
          phone: import.meta.env.VITE_PHONE,
          mailTo: import.meta.env.VITE_MAILTO
        };
    },
};
</script>

<style
  lang="scss"
  scoped
>
.footer__contacts {
  font-size: 20px;
  line-height: 1;
  padding: 16px;
  border-radius: 16px;
  background-color: $green-shade;

  &-item {
    margin-bottom: 16px;
  }

  @media (max-width: $breakpoint-xs) {
    font-size: 16px;
  }
}
</style>